import VipService from '../../service/vip';

const Action = {
    GET_VIP: "[TRIAL_VIP] GET_VIP",
    GET_VIPS: "[TRIAL_VIP] GET_VIPS",
    UPDATE_VIP: "[TRIAL_VIP] UPDATE_VIP",
    NEW_TRIAL_VIP: "NEW_TRIAL_VIP",
    GET_TRIAL_VIP: "GET_TRIAL_VIP",
    GET_TRIAL_VIPS: "GET_TRIAL_VIPS",
    UPDATE_TRIAL_VIP: "UPDATE_TRIAL_VIP",
    DISABLE_TRIAL_VIP: "DISABLE_TRIAL_VIP",
};

const ActionCreator = {

    addTrialVip() {
        return async (dispatch) => {
            try {
                const trialVip = await VipService.addTrialVip();
                dispatch({type: Action.NEW_TRIAL_VIP, trialVip});
                return trialVip;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getTrialVip(vipId) {
        return async (dispatch) => {
            try {
                const trialVip = await VipService.findTrialVipById(vipId);
                dispatch({type: Action.GET_TRIAL_VIP, trialVip});
                return trialVip;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getTrialVips() {
        return async (dispatch) => {
            try {
                const trialVips = await VipService.listTrialVips();
                dispatch({type: Action.GET_TRIAL_VIPS, trialVips});
                return trialVips;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    updateTrialVip(trialVip) {
        return async (dispatch) => {
            try {
                const newTrialVip = await VipService.updateTrialVip(trialVip);
                dispatch({type: Action.UPDATE_TRIAL_VIP, trialVip: newTrialVip});
                return newTrialVip;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    disableTrialVip(vipId) {
        return async (dispatch) => {
            try {
                await VipService.disableTrialVip(vipId);
                return dispatch(ActionCreator.getTrialVip(vipId));
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
};

const initialState = {
    vips: [],
    trialVips: [],
    vip: {},
    trialVip: {},
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_VIP:
        case Action.UPDATE_VIP:
            return {
                ...state,
                vip: action.vip
            };
        case Action.NEW_TRIAL_VIP:
        case Action.GET_TRIAL_VIP:
        case Action.UPDATE_TRIAL_VIP:
        case Action.DISABLE_TRIAL_VIP:
            return {
                ...state,
                trialVip: action.trialVip
            };
        case Action.GET_VIPS:
            return {
                ...state,
                vips: action.vips
            };
        case Action.GET_TRIAL_VIPS:
            return {
                ...state,
                trialVips: action.trialVips
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/trialVip.js